import IconArrow from '@/images/icon-arrow.svg?react';
import IconBackArrowPrimary from '@/images/icon-back-arrow-primary.svg?react';
import IconBackArrow from '@/images/icon-back-arrow.svg?react';
import IconCalendar from '@/images/icon-calendar.svg?react';
import IconCheckCircle from '@/images/icon-check-circle.svg?react';
import IconCheck from '@/images/icon-check.svg?react';
import IconDoc from '@/images/icon-doc.svg?react';
import IconDownload from '@/images/icon-download.svg?react';
import IconProfile from '@/images/icon-profile.svg?react';
import IconRemove from '@/images/icon-remove.svg?react';
import IconReviewing from '@/images/icon-reviewing.svg?react';
import IconTooltip from '@/images/icon-tooltip.svg?react';
import IconUpload from '@/images/icon-upload.svg?react';

const iconMapping = {
  arrow: IconArrow,
  tooltip: IconTooltip,
  calendar: IconCalendar,
  upload: IconUpload,
  download: IconDownload,
  remove: IconRemove,
  doc: IconDoc,
  check: IconCheck,
  reviewing: IconReviewing,
  backArrowPrimary: IconBackArrowPrimary,
  checkCircle: IconCheckCircle,
  profile: IconProfile,
  backArrow: IconBackArrow,
};

export default iconMapping;
